<script setup lang="ts">
import { computed } from "vue";
import LockIcon from "@/components/shared/icons/LockIcon.vue";

const props = withDefaults(
  defineProps<{
    text: string;
    tooltip?: string;
    dataTestid?: string;
  }>(),
  {
    tooltip: "",
    dataTestid: "my-students-status-lock-badge",
  },
);

const tooltipConfig = computed(() => ({
  value: props.tooltip,
  disabled: !props.tooltip,
  escape: true,
  class: "bg-white max-w-xs shaddow rounded white",
  hideDelay: "0.3",
  pt: {
    text: "text-indigo-base p-3 leading-none",
  },
}));
</script>

<template>
  <span
    v-tooltip.top="tooltipConfig"
    class="inline-flex items-center gap-1 text-11p font-bold uppercase tracking-wider text-gray-600"
    :data-testid="dataTestid"
  >
    <LockIcon class="w-3 h-3" />
    {{ text }}
  </span>
</template>
